import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { SessionService } from "../../../../@core/session/session.service";
import { Store } from "../../../../@core/store/store";
import { DynamicStackService } from "../service/dynamic-stack.service";
import {
  RemindersLoadedState,
  RemindersLoadingErrorState,
  RemindersLoadingState,
} from "../service/dynamic-stack.state";
import { AppLocalStorage } from "../../../../@core/utils/local-storage.util";

@Component({
  selector: "ltts-reminders",
  templateUrl: "./reminders.component.html",
  styleUrls: ["./reminders.component.scss"],
})
export class RemindersComponent implements OnInit {
  remindersHeading: string = "Reminders";
  remindersData: any[] = [];
  reminderLoading: boolean;
  constructor(private dynamicStackService: DynamicStackService, private sessionService: SessionService, private cdRef: ChangeDetectorRef) { 
  }

  @Input()
    set remindersLoading(value) {
      this.reminderLoading = value;
      //this.cdRef.detectChanges();
    }

   @Input()
    set reminders(value) {
      this.remindersData = value;
      //this.cdRef.detectChanges();
    }
    
  ngOnInit(): void {
    //const me = this;
    //const userId = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")?.profile?.employeeId
    //me.getRemindersListData(userId);
  }


  getRemindersListData(userId) {
      const me = this;
    me.dynamicStackService.getReminderData(userId).subscribe(
      (state: Store.State) => {
        if (state instanceof RemindersLoadingState) {
          return;
        }
        if (state instanceof RemindersLoadedState) {
          me.remindersData = state?.data?.data;
          this.cdRef.detectChanges();

          return;
        }
      },
      (state: RemindersLoadingErrorState) => {
        return;
      }
    );
  }
}
